import React from 'react';
import ObjectBrowserWidget from '@plone/volto/components/manage/Widgets/ObjectBrowserWidget';
import { CheckboxWidget } from '@plone/volto/components';
import ContactColorWidget from './ContactColorWidget';
import { useIntl } from 'react-intl';
import messages from '../../../../messages';

const EditSchema = ({ data = {}, onChangeBlock, block, navRootPath = '/' }) => {
  const intl = useIntl();

  const FIELD_CHOICES = [
    ['salutation', intl.formatMessage(messages.contactChoiceSalutation)],
    ['name', intl.formatMessage(messages.contactChoiceName)],
    ['surname', intl.formatMessage(messages.contactChoiceSurname)],

    ['institution', intl.formatMessage(messages.contactChoiceInstitution)],

    ['role', intl.formatMessage(messages.contactChoiceRole)],
    ['department', intl.formatMessage(messages.contactBlockDepartment)],
    ['research_priorities', intl.formatMessage(messages.contactChoicePriority)],
    ['functions', intl.formatMessage(messages.contactChoiceFunctions)],
    ['faculty', intl.formatMessage(messages.contactBlockFaculty)],

    ['street', intl.formatMessage(messages.contactChoiceStreet)],
    ['room', intl.formatMessage(messages.contactChoiceRoom)],
    ['location', intl.formatMessage(messages.contactChoiceLocation)],

    ['phone', intl.formatMessage(messages.contactChoicePhone)],
    ['email', intl.formatMessage(messages.contactChoiceEmail)],
    ['image', intl.formatMessage(messages.contactChoiceImage)],
  ];

  const allKeys = FIELD_CHOICES.map(([key]) => key);

  const hasVisibleFields =
    Array.isArray(data.visibleFields) && data.visibleFields.length > 0;

  const initialVisibleArray = hasVisibleFields ? data.visibleFields : allKeys;
  const visible = new Set(initialVisibleArray);

  if (!hasVisibleFields) {
    onChangeBlock(block, {
      ...data,
      visibleFields: initialVisibleArray,
    });
  }

  const toggle = (key) => {
    const s = new Set(visible);
    if (s.has(key)) {
      s.delete(key);
    } else {
      s.add(key);
    }

    onChangeBlock(block, {
      ...data,
      visibleFields: [...s],
    });
  };

  const setStyle = (id, val) =>
    onChangeBlock(block, {
      ...data,
      [id]: val,
    });

  return (
    <div className="contact-sidebar">
      <header className="contact-sidebar__header">
        <h2 className="contact-sidebar__title">FCMH: Contact</h2>
      </header>

      <fieldset className="contact-sidebar__fieldset">
        <legend className="contact-sidebar__legend">
          {intl.formatMessage(messages.contactBlockHeadline)}
        </legend>
        <input
          type="text"
          className="contact-sidebar__input"
          value={data.headline || ''}
          onChange={(e) =>
            onChangeBlock(block, { ...data, headline: e.target.value })
          }
          placeholder="Optionale Überschrift…"
        />
      </fieldset>

      <fieldset className="contact-sidebar__fieldset contact-sidebar__fieldset--browser">
        <legend className="contact-sidebar__legend">
          {intl.formatMessage(messages.contactChoose)}
        </legend>
        <ObjectBrowserWidget
          id="contact"
          title={intl.formatMessage(messages.contactChoose)}
          mode="link"
          value={data.contact || []}
          maximumSelectionSize={1}
          selectableTypes={['Contact']}
          searchableTypes={['Contact']}
          currentPath={navRootPath}
          onChange={(id, value) =>
            onChangeBlock(block, { ...data, contact: value })
          }
        />
      </fieldset>

      <fieldset className="contact-sidebar__fieldset">
        <legend className="contact-sidebar__legend">
          {intl.formatMessage(messages.contactFieldsDisplayDescription)}
        </legend>

        <div className="contact-sidebar__checks">
          {FIELD_CHOICES.map(([key, label]) => (
            <React.Fragment key={key}>
              {key === 'institution' && (
                <div className="contact-sidebar__subfield">
                  <div className="contact-sidebar__sublabel">
                    {intl.formatMessage(messages.contactInstitutionHeadline)}
                  </div>
                  <input
                    type="text"
                    className="contact-sidebar__input"
                    value={data.institutionLabel || ''}
                    onChange={(e) =>
                      onChangeBlock(block, {
                        ...data,
                        institutionLabel: e.target.value,
                      })
                    }
                    placeholder="z. B. Institution"
                  />
                  <p className="contact-sidebar__help">
                    {intl.formatMessage(messages.contactInstitutionDesc)}
                  </p>
                </div>
              )}

              <CheckboxWidget
                id={`vis-${key}`}
                title={label}
                value={visible.has(key)}
                onChange={() => toggle(key)}
              />
            </React.Fragment>
          ))}
        </div>
      </fieldset>

      <fieldset className="contact-sidebar__fieldset">
        <legend className="contact-sidebar__legend">
          {' '}
          {intl.formatMessage(messages.contactColor)}
        </legend>
        <ContactColorWidget
          id="theme"
          value={data.theme || 'white'}
          onChange={setStyle}
        />
      </fieldset>
    </div>
  );
};

export default EditSchema;
